export default function DownloadCanvas(canvas: HTMLCanvasElement, filename: string, mime: string) {
   const form = document.getElementById('chart-download') as HTMLFormElement;
   const textarea = document.getElementById('chart-download-data') as HTMLTextAreaElement;
   const chartTitle = document.getElementById('chart-download-title') as HTMLInputElement;
   let base64String = canvas.toDataURL(mime);
   const prefixIndex = base64String.indexOf(',');
   base64String = base64String.substr(prefixIndex + 1);
   textarea.value = base64String;
   chartTitle.value = filename;
   form.onsubmit = e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
   };
   form.submit();
}
